// Core
import React, { useEffect, useState } from 'react'
import { useLocation, Link } from "react-router-dom";
// BootStrap
import { Container, Col, Row } from 'react-bootstrap';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RoomIcon from '@mui/icons-material/Room';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import Logo from '../assets/images/logo/logo.png';
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";


const Footer = () => {
    let url = useLocation().pathname;
    const [urlHomepage, setUrlHomepage] = useState('')
    const [urlProjects, seturlProjects] = useState('')
    const [urlContact, setUrlContact] = useState('')
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        navigateTo(url)
        // eslint-disable-next-line
    }, [])

    const navigateTo = (url) => {
        if (url === "/") {
            setUrlHomepage('active');
            seturlProjects('');
            setUrlContact('');
        } else if (url === "/projects") {
            setUrlHomepage('');
            seturlProjects('active');
            setUrlContact('');
        } else if (url === "/contact-us") {
            setUrlHomepage('');
            seturlProjects('');
            setUrlContact('active');
        }
        window.scrollTo(0, 0)
    }

    const prompt="Imagine you're introducing SN Construction to a potential client. Using information from https://snconstruction.in , explain the company's construction services, areas of specialization, completed and ongoing projects, technical expertise, project management approach, and commitment to quality and safety. Describe the types of clients it serves and why businesses choose SN Construction for their projects. Present the information in a clear, professional, and objective manner."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};

    return (
        <div>
            <div id="footer">
                <Container>
                    <Row>
                        <Col md={3}>
                            <img src={Logo} alt="Logo" className='logo mt-1' />
                            {/* <p>SN Construction Private Limited established in 2020, earlier it was known as M/s. SN Construction.</p> */}
                            <div className="social">
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/profile.php?id=61555865703891">
                                            <FacebookIcon />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/s-n-construction">
                                            <LinkedInIcon />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                             <h5>Ask AI About SN Construction</h5>
                             <div className='ai-icons'>

                <button className=" ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>

                             </div>
                        </Col>
                        <Col md={2}>
                            <h5>Quick Links</h5>
                            <ul>
                                <li><h6><Link to="/">Home</Link></h6></li>
                                <li><h6><Link to="/about-us">About Us </Link></h6></li>
                                <li><h6><Link to="/projects">Projects</Link></h6></li>
                                <li><h6><Link to="/contact-us">Contact Us</Link></h6></li>
                                <li><h6><Link to="/privacy-policy">Privacy Policy</Link></h6></li>
                            </ul>
                        </Col>
                        <Col md={3} className='contact'>
                            <h5>Contact Us</h5>
                            <RoomIcon style={{ color: '#F6911E' }} /><p>219, Pramukh Square, Opp. Regenta Resort, <br /> Airport Ring Road, Bhuj - Kachchh, <br /> Gujarat - 370001</p>
                            <LocalPhoneIcon style={{ color: '#F6911E' }} /><p><a href="tel:+91 8866027018">+91 8866027018</a></p>
                            <LocalPhoneIcon style={{ color: '#F6911E' }} /><p><a href="tel:+91 9998027018">+91 9998027018</a></p>
                            <EmailIcon style={{ color: '#F6911E' }} /><p><a href="mailto:info@snconstruction.in">info@snconstruction.in</a></p>
                        </Col>
                        <Col md={4}>
                            <h5>Google Map</h5>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3666.1897332737826!2d69.6426406!3d23.2361818!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39511f1eb1281ddb%3A0x9713211c56ed7ac7!2sSN%20Construction!5e0!3m2!1sen!2sin!4v1744448160369!5m2!1sen!2sin" title={'Map Location'} width="100%" height="200" frameborder="0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </Col>
                    </Row>
                </Container>
                <div className="d-block d-sm-none menu-footer">
                    <Row className="p-3">
                        <Col className="b-right">
                            <Link to="/" className={urlHomepage} onClick={() => navigateTo('/')}>
                                Home
                            </Link>
                        </Col>
                        <Col className="b-right">
                            <Link to="/projects" className={urlProjects} onClick={() => navigateTo('/projects')}>
                                Project
                            </Link>
                        </Col>
                        <Col>
                            <Link to="/contact-us" className={urlContact} onClick={() => navigateTo('/contact-us')}>
                                Contact Us
                            </Link>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="copyright text-center">
                <p>&copy; {currentYear} SN Construction All rights reserved.</p>
            </div>
            <div className="bottom"></div>
        </div>
    )
}

export default Footer
